// Forwarded messages that haven't landed yet, shown in the chat they're going to as
// "sending" bubbles (like WhatsApp), so a big forward doesn't look like nothing happened.
// When the server has them, each is swapped for its real message in one go - never both
// on screen, never a gap. A landed item carries that message until its chat takes it in.
const EMPTY = [];
const pending = new Map(); // conversationId -> items
const listeners = new Set();
const emit = () => listeners.forEach((listener) => listener());

export const getPendingForwards = (conversationId) => pending.get(conversationId) || EMPTY;

// Logged out: none of them is shown to whoever logs in next in this tab
export const forgetPendingForwards = () => {
  pending.clear();
  emit();
};

export const subscribePendingForwards = (listener) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

export const addPendingForwards = (conversationId, items) => {
  pending.set(conversationId, [...getPendingForwards(conversationId), ...items]);
  emit();
};

export const removePendingForwards = (conversationId, ids) => {
  const remaining = getPendingForwards(conversationId).filter((item) => !ids.includes(item.clientMessageId));
  if (remaining.length) pending.set(conversationId, remaining);
  else pending.delete(conversationId);
  emit();
};

// The forward is done: each sending item gets its real message, in order. One the server
// didn't send (e.g. the original was deleted meanwhile) just goes
export const landPendingForwards = (conversationId, ids, messages) => {
  const landed = new Map(ids.map((id, index) => [id, messages[index]]));
  const remaining = getPendingForwards(conversationId)
    .map((item) => (landed.has(item.clientMessageId) ? { ...item, message: landed.get(item.clientMessageId) } : item))
    .filter((item) => !landed.has(item.clientMessageId) || item.message);
  if (remaining.length) pending.set(conversationId, remaining);
  else pending.delete(conversationId);
  emit();
};
